import { render } from "./AuthorizationRenderer.vue?vue&type=template&id=c92bd004&scoped=true"
import script from "./AuthorizationRenderer.vue?vue&type=script&lang=js"
export * from "./AuthorizationRenderer.vue?vue&type=script&lang=js"

import "./AuthorizationRenderer.vue?vue&type=style&index=0&id=c92bd004&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92bd004"]])

export default __exports__